<mat-dialog-content>
  <div class="container">
    <fs-cgu-display [cgu]="data.cgu" (output)="close($event)" [readOnly]="data.readOnly" class="cgu-display"></fs-cgu-display>
  </div>
</mat-dialog-content>
